import type {
  SectionCandidate,
  SectionDescriptor,
} from '../SectionBuilders/types';
import type { INavigationItem } from '../Sections/StickyNavigationBar/StickyNavigationBar';

export const sectionAnchorId = (sectionId: string): string =>
  `section-${sectionId}`;

/** Keeps the sections a builder marked visible, in its order. */
export const visibleSections = (
  sections: SectionCandidate[],
): SectionDescriptor[] =>
  sections
    .filter((section) => section.visible)
    .map(({ visible: _visible, ...section }) => section);

/** Sticky-nav tabs in render order; a section without a label is rendered but gets no tab. */
export const getNavigationItems = (
  sections: SectionDescriptor[],
): INavigationItem[] =>
  sections.flatMap((section) =>
    section.label ? [{ id: section.id, label: section.label }] : [],
  );
